var map = {
	"./\biron_LOGO.png": 9512,
	"./ADSOL_LOGO.png": 8967,
	"./AmericanWineries_LOGO.png": 5922,
	"./Demo_LOGO.png": 2011,
	"./KAVALAN_LOGO.png": 594,
	"./OTOKI_LOGO.png": 7710,
	"./PKG_LOGO.png": 5592,
	"./PNK_LOGO.png": 8993,
	"./POST_LOGO.png": 4818,
	"./SDAA_LOGO.png": 49,
	"./SKKU_LOGO.png": 5930,
	"./SOLUM_LOGO.png": 1390,
	"./Skaichips_LOGO.png": 4621,
	"./Test_LOGO.png": 7548,
	"./Wintest_LOGO.png": 9704,
	"./dea_LOGO.png": 9536
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8003;